// src/components/Header.jsx
import React, { useState, useEffect, useRef, use } from "react";
import LoginModal from "../pages/Login/LoginModal";
import storage from "../utils/storage";

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false); // Add logged in state
  const [name, setName] = useState(""); // Add name state

  const headerRef = useRef(null);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const checkLoginStatus = () => {
    // Retrieve access token and name from storage
    const token = storage.getAccessToken();
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }

    const name = storage.getItem("name");
    setName(name);
  };

  const handleLogout = () => {
    // Clear the access token and name from storage
    storage.clearStorage();
    setIsLoggedIn(false);
    window.location.href = "/";
  };

  // Menu data as objects for better management
  const menuItems = {
    home: {
      title: "Home",
      href: "/",
    },
    recharge: {
      title: "Recharge",
      submenu: [
        { title: "Mobile Recharge", href: "/mobile-recharge" },
        { title: "DTH Recharge", href: "/dth-recharge" },
     //  { title: "Fastag Recharge", href: "/bill-payment/Fastag" },
        { title: "Google Play Redeem Code", href: "/google-play-redeem-code" },
      //   {
      //     title: "Electricity Bill Payment",
      //     href: "/bill-payment/Electricity",
      //   },
      //   {
      //     title: "Mobile Postpaid Bill Payment",
      //     href: "/bill-payment/Postpaid",
      //   },
      //   { title: "Landline Bill Payment", href: "/bill-payment/Landline" },
      //   { title: "Broadband Bill Payment", href: "/bill-payment/Broadband" },
      //   { title: "Loan Repayment", href: "/bill-payment/Loan%20Repayment" },
      //   { title: "LPG Booking", href: "/bill-payment/LPG%20Booking" },
      //   // { title: "Insurance", href: "/bill-payment/Insurance" },
      //   { title: "Water", href: "/bill-payment/Water" },
      ],
    },
    about: {
      title: "About Us",
      href: "/about-us", // This item has no submenu
    },
  };

  const profileMenu = {
    title: "My Profile",
    submenu: [
      { title: `Hi, ${name ? name : "-"}`, isHeading: true },
      { divider: true },
      {
        title: "View Profile",
        href: "/profile",
        icon: "fas fa-user",
      },
      {
        title: "Transactions",
        href: "/transactions",
        icon: "fas fa-history",
      },
      { divider: true },
      { title: "Need Help?", href: "/support", icon: "fas fa-life-ring" },
      {
        title: "Logout",
        href: "#",
        icon: "fas fa-sign-out-alt",
        onClick: handleLogout, // Add logout functionality
      },
    ],
  };

  // Check if mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (dropdownName) => {
    if (isMobileView) {
      setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    } else {
      setActiveDropdown(dropdownName);
    }
  };

  const closeDropdown = () => {
    if (!isMobileView) {
      setActiveDropdown(null);
    }
  };

  const toggleMobileNav = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  // Render menu items recursively
  const renderMenuItems = (menuData, parentKey = "") => {
    return Object.entries(menuData).map(([key, item]) => {
      const fullKey = parentKey ? `${parentKey}-${key}` : key;
      const hasSubmenu = !!item.submenu;

      return (
        <li
          key={fullKey}
          className={`dropdown ${
            hasSubmenu ? (activeDropdown === fullKey ? "show" : "") : ""
          }`}
          onMouseEnter={
            !isMobileView && hasSubmenu
              ? () => toggleDropdown(fullKey)
              : undefined
          }
          onMouseLeave={!isMobileView && hasSubmenu ? closeDropdown : undefined}
        >
          <a
            className={hasSubmenu ? "dropdown-toggle" : ""}
            href={item.href || "#"}
            onClick={(e) => {
              if (hasSubmenu || !item.href) {
                e.preventDefault();
                if (hasSubmenu) {
                  toggleDropdown(fullKey);
                }
              }
            }}
          >
            {item.title}
            {hasSubmenu && (
              <span className="dropdown-icon">
                <i
                  className="fas fa-chevron-down ms-1"
                  style={{ fontSize: "0.75rem" }}
                />
              </span>
            )}
            {item.icon && <i className={item.icon} />}
          </a>

          {hasSubmenu && (
            <ul
              className={`dropdown-menu ${
                activeDropdown === fullKey ? "show" : ""
              }`}
            >
              {Array.isArray(item.submenu)
                ? item.submenu.map((subItem, index) => (
                    <React.Fragment key={`${fullKey}-${index}`}>
                      {subItem.divider ? (
                        <li className="dropdown-divider mx-n3" />
                      ) : subItem.isHeading ? (
                        <li className="text-center text-3 py-2">
                          {subItem.title}
                        </li>
                      ) : (
                        <li>
                          <a
                            className="dropdown-item"
                            href={subItem.href}
                            onClick={(e) => {
                              if (subItem.onClick) {
                                e.preventDefault();
                                subItem.onClick();
                              }
                            }}
                          >
                            {subItem.icon && (
                              <i className={`${subItem.icon} me-2`} />
                            )}
                            {subItem.title}
                          </a>
                        </li>
                      )}
                    </React.Fragment>
                  ))
                : renderMenuItems(item.submenu, fullKey)}
            </ul>
          )}
        </li>
      );
    });
  };

  return (
    <div ref={headerRef}>
      <header id="header">
        <div className="container">
          <div className="header-row">
            <div className="header-column justify-content-start">
              <div className="logo me-2 me-lg-3">
                <a href="/" className="d-flex" title="Logo">
                  <img src="/assets/images/logo.png" alt="Logo" width={180} />
                </a>
              </div>
            </div>

            <div className="header-column justify-content-end">
              <nav className="primary-menu navbar navbar-expand-lg">
                <div
                  id="header-nav"
                  className={`collapse navbar-collapse ${
                    mobileNavOpen ? "show" : ""
                  }`}
                >
                  <ul className="navbar-nav">{renderMenuItems(menuItems)}</ul>
                </div>
              </nav>

              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleMobileNav}
                aria-label="Toggle navigation"
              >
                <span /> <span /> <span />
              </button>

              <div className="vr mx-2 h-25 my-auto" />

              <nav className="login-signup navbar navbar-expand">
                <ul className="navbar-nav">
                  {isLoggedIn ? (
                    <li
                      className={`profile dropdown ${
                        activeDropdown === "profile" ? "show" : ""
                      }`}
                      onMouseEnter={
                        !isMobileView
                          ? () => toggleDropdown("profile")
                          : undefined
                      }
                      onMouseLeave={!isMobileView ? closeDropdown : undefined}
                    >
                      <a
                        className="pe-0 dropdown-toggle"
                        href="#"
                        title={profileMenu.title}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleDropdown("profile");
                        }}
                      >
                        <span className="d-none d-sm-inline-block">
                          {profileMenu.title}
                        </span>
                        <span className="user-icon ms-sm-2">
                          <i className="fas fa-user" />
                        </span>
                        <span className="dropdown-icon">
                          <i
                            className="fas fa-chevron-down ms-1"
                            style={{ fontSize: "0.75rem" }}
                          />
                        </span>
                      </a>
                      <ul
                        className={`dropdown-menu ${
                          activeDropdown === "profile" ? "show" : ""
                        }`}
                      >
                        {profileMenu.submenu.map((item, index) => (
                          <React.Fragment key={`profile-${index}`}>
                            {item.divider ? (
                              <li className="dropdown-divider mx-n3" />
                            ) : item.isHeading ? (
                              <li className="text-center text-3 py-2">
                                {item.title}
                              </li>
                            ) : (
                              <li>
                                <a
                                  className="dropdown-item"
                                  href={item.href}
                                  onClick={(e) => {
                                    if (item.onClick) {
                                      e.preventDefault();
                                      item.onClick();
                                    }
                                  }}
                                >
                                  {item.icon && (
                                    <i className={`${item.icon} me-2`} />
                                  )}
                                  {item.title}
                                </a>
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                      </ul>
                    </li>
                  ) : (
                    <li className="login-item">
                      <a
                        href="#"
                        onClick={handleLoginClick}
                        className="d-flex align-items-center"
                      >
                        <span className="d-none d-sm-inline-block">
                          Login/Signup
                        </span>
                        <span className="user-icon ms-sm-2">
                          <i className="fas fa-user" />
                        </span>
                      </a>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <LoginModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onLoginSuccess={() => setIsLoggedIn(true)} // Add login success handler
      />
    </div>
  );
};

export default Header;
